"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hue = void 0;
var hue = function (h) { return h; };
exports.hue = hue;
